// /v1/course/info接口信息处理
// 商品详情页、拼团分享页、教师端课程详情页等--课程课时信息+课程有效期处理
import moment from "moment";
export default {
  data() {
    return {
      canTrial: false,
      canTrialLseeon: {}, //第一个可试听的课
      inThreeDaysLiveLesson: [],
    };
  },
  methods: {
    handleCourseInfoData(data) {
      // 处理课程有效期
      this.handleValidityPeriod(data);
      // 处理课时数
      let liveNum = 0;
      let vidoeNum = 0;
      let workNum = 0;
      if (data.unit_list && data.unit_list.length) {
        data.unit_list.forEach((unit) => {
          if (unit.lesson_list && unit.lesson_list.length) {
            unit.lesson_list.forEach((lesson) => {
              if (lesson.lesson_type === 2) {
                liveNum++;
                // 直播课状态处理
                this.handleLiveStatus(lesson);
                // 处理直播间状态
                this.handleRoomStatus(lesson);
                // 提示信息处理
                this.handleLiveTips(lesson);
                // 筛选出三天内直播课
                if ([3, 4].includes(lesson.liveStatus)) {
                  this.isInThreeDaysLiveLesson(lesson);
                }
              } else if (lesson.lesson_type === 1) {
                vidoeNum++;
              } else {
                workNum++;
              }
              // 是否可试听-直播或点播
              if ([1, 2].includes(lesson.lesson_type)) {
                if (lesson.trial_duration != 0) {
                  this.canTrial = true;
                  if (!this.canTrialLseeon?.id) {
                    this.canTrialLseeon = lesson;
                  }
                  // 可试听
                  lesson.canTrial = 1;
                }
              }
            });
          }
        });
      }
      data.lessonNum = vidoeNum + liveNum + workNum;
      data.vidoeNum = vidoeNum;
      data.liveNum = liveNum;
      data.workNum = workNum;

      // 处理私教课
      if (data.private_unit_list?.length) {
        data.private_unit_list.forEach((unit) => {
          if (unit?.lesson_list?.length) {
            let lessonList = unit?.lesson_list.filter(
              (lesson) => lesson.lesson_type === 4
            );
            lessonList.forEach((lesson) => {
              if (lesson.lesson_type === 4) {
                // 直播课状态处理
                this.handleLiveStatus(lesson);
                // 处理直播间状态
                this.handleRoomStatus(lesson);
                // 提示信息处理
                this.handleLiveTips(lesson);
                // 老师列表
                let arr = [];
                (lesson?.assistant || []).forEach((assistant) => {
                  arr.push(assistant.org_nickname);
                });
                lesson.teachers = arr.join("、");
              }
            });
            unit.lesson_list = lessonList;
          }
        });
      }
      return data;
    },
    isInThreeDaysLiveLesson(lesson) {
      let todayTime = new Date().setHours(0, 0, 0, 0) / 1000;
      let threeDaysTime = todayTime + 24 * 60 * 60 * 3;
      let now = new Date().getTime();
      let { live_start_time } = lesson;
      if (live_start_time >= todayTime && live_start_time < threeDaysTime) {
        if (live_start_time * 1000 < now + 4 * 60 * 60 * 1000) {
          lesson.inFourHours = true;
        } else if (
          live_start_time >= todayTime &&
          live_start_time < todayTime + 24 * 60 * 60
        ) {
          lesson.isToday = true;
        } else if (
          live_start_time >= todayTime + 24 * 60 * 60 &&
          live_start_time < todayTime + 24 * 60 * 60 * 2
        ) {
          lesson.inTomorrow = true;
        }
        this.inThreeDaysLiveLesson.push(lesson);
      }
    },
    handleValidityPeriod(data) {
      if (data.validity_type) {
        if (data.validity_type === 2) {
          data.validityPeriod = `随到随学${data.enrollment_days}天`;
        } else if (data.validity_type === 3) {
          data.validityPeriod = `永久有效`;
        } else if (data.validity_type === 1) {
          data.validityPeriod = `至${moment(data.course_end_time * 1000).format(
            "YYYY年MM月DD日"
          )}`;
        }
      } else {
        data.validityPeriod = "";
      }
    },
    handleLiveStatus(item) {
      let begin = item.live_start_time;
      let end = item.live_end_time;
      let now = new Date().getTime();
      // 可提前进入
      if (item.first_join_time) {
        begin = begin - item.first_join_time * 60;
      }
      if (end * 1000 < now) {
        // 已结束
        item.status = 3;
      } else if (begin * 1000 > now) {
        // 未开始
        item.status = 1;
      } else {
        // 已开始
        item.status = 2;
      }
    },
    // 处理直播间状态
    handleRoomStatus(item) {
      let { room_start_time, room_end_time } = item;
      if (room_start_time > 0 && !room_end_time) {
        item.roomStatus = 2;
        item.roomStatusText = "上课中";
      } else if (room_end_time > 0) {
        item.roomStatus = 3;
        item.roomStatusText = "已下课";
      } else {
        item.roomStatus = 1;
        item.roomStatusText = "未开始";
      }
    },
    handleLiveTips(lesson) {
      if (lesson.record_url && lesson.is_record === 1) {
        lesson.liveStatus = 1;
        lesson.tips = "观看视频";
      } else if (lesson.roomStatus === 3 && lesson.is_record === 1) {
        lesson.liveStatus = 2;
        lesson.tips = "回放生成中";
      } else if (lesson.status === 2 || lesson.roomStatus === 2) {
        // 直播间开始上课|到后台设置的课程开始时间
        lesson.liveStatus = 3;
        lesson.tips = "进入教室";
      } else if (lesson.status === 1 && lesson.first_join_time) {
        lesson.liveStatus = 4;
        lesson.tips = `提前${lesson.first_join_time}分钟才可进入`;
      }
    },
  },
};
